// extracted by mini-css-extract-plugin
export default {"tabTitle":"CustomerDataTabs_tabTitle__hLgQI"};